// Track visitors
import sbjs from 'sourcebuster';
sbjs.init()


let sbjsInitFinished = false;

export function GetAnalytics():AnalyticsData { 
    if (!sbjsInitFinished) {
        sbjs.init()
    }
    
    return sbjs.get
}

// @ts-ignore
window.sbjs  = sbjs.get;



/***
 * TYPE DEFINITIONS, NO CODE BELOW
 */
interface AnalyticsAddress {
    /**
     * URL
     */
    ep: string
    /**
     * Address date
     */
    fd: string
    /**
     * Referer ("(none)" if not present)
     */
    rf: string
}

interface AnalyticsUTMS {
    /**
     * Campaign. Value of utm_campaign. (none) if there is none
     */
    cmp: string
    /**
     * Content. Value of utm_content. (none) if there is none
     */
    cnt: string
    /**
     * Medium, utm_medium. Values can be customized via utm-params and referrals. (none) if there is none
     */
    mdm:string
    /**
     * Source. utm_source, actually. (none) if there is none
     */
    src: string
    /**
     * Keyword. Value of utm_term. (none) if there is none
     */
    trm: string
    /**
     * Traffic type. Possible values: utm, organic, referral, typein. 
     */
    typ: string
}

export interface AnalyticsData {
    /**
     * Params of the latest visitor’s source. If a visitor had more than one source, this will be the latest.
     */
    current?: AnalyticsUTMS,
    /**
     * Additional info about a visit.
     */
    current_add?: AnalyticsAddress
    /**
     * Just like sbjs.get.current & sbjs.get.current_add, but holds data of the very first visit. Stored once, never overwritten.
     */
    first?: AnalyticsUTMS
    /**
     * Just like sbjs.get.current & sbjs.get.current_add, but holds data of the very first visit. Stored once, never overwritten.
     */
    first_add?:  AnalyticsAddress
    /**
     * Visitor’s promocode. This cookie is set only if promocode param is present.
     */
    promo?: {
        /**
         * Promocode.
         */
        code?: string 
    }
    /**
     * Current opened session data.
     */
    session?: {
        /**
         * Current page URL.
         */
        cpg: string
        /**
         * How many pages user have seen during the current session.
         */
        pgs: string
    }
    /**
     * Additional user data: visits, ip & user-agent.
     */
    udata?: {
        /**
         * Current user-agent (browser).
         */
        uag: string
        /**
         * Current ip-address. ("(none)" if not present)
         */
        uip: string
        /**
         * How many times user visited site.
         */
        vst:string
    }
}